import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-20" data-id="element-70">
      <div className="mx-auto max-w-3xl" data-id="element-71">
        <div className="rounded-2xl bg-navy-950 p-8 sm:p-12 border-2 border-gold-500/30 shadow-2xl text-center relative overflow-hidden" data-id="element-72">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -z-10 h-[200px] w-[200px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-500/10 blur-[80px]" data-id="element-73"></div>

          <div className="mb-6 flex justify-center" data-id="element-74">
            <div className="relative" data-id="element-75">
              <div className="absolute inset-0 rounded-full bg-gold-500/20 blur-xl" data-id="element-76"></div>
              <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-navy-900 border-2 border-gold-400" data-id="element-77">
                <ShieldCheck className="h-10 w-10 text-gold-400" data-id="element-78" />
              </div>
            </div>
          </div>

          <h2 className="mb-4 text-4xl sm:text-5xl font-bebas text-white" data-id="element-79">
            Garantía Total de <span className="text-gold-400" data-id="element-80">7 Días</span>
          </h2>

          <p className="text-lg sm:text-xl text-slate-200 leading-relaxed max-w-xl mx-auto" data-id="element-81">
            Si en 7 días no ves el valor del sistema, te devolvemos cada
            centavo.{' '}
            <span className="text-white font-semibold" data-id="element-82">
              Sin preguntas. Sin trámites.
            </span>
          </p>
        </div>
      </div>
    </section>;
}